/* Meubléa — motion design premium (couche 2)
   Titres en mots, rideaux d'images, parallaxe, barre de lecture,
   boutons magnétiques, cartes 3D, curseur, bandeau défilant. */
(function () {
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cfg = window.MB_MOTION || {};
  var design = window.Shopify && Shopify.designMode;

  /* ---------- Observateur commun ---------- */
  var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      el.classList.add('is-in');
      if (el.classList.contains('mb-split-ready')) el.classList.add('is-words-in');
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }) : null;

  function watch(el) {
    if (io) io.observe(el);
    else { el.classList.add('is-in'); el.classList.add('is-words-in'); }
  }

  /* ---------- 1. Titres découpés en mots ---------- */
  function splitWords(el) {
    if (el.dataset.mbSplit) return;
    el.dataset.mbSplit = '1';
    var i = 0;
    var label = el.textContent.replace(/\s+/g, ' ').trim();
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/);
          var frag = doc.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(doc.createTextNode(' ')); return; }
            var w = doc.createElement('span'); w.className = 'mb-w'; w.setAttribute('aria-hidden', 'true');
            var inner = doc.createElement('span'); inner.className = 'mb-w__i';
            inner.style.setProperty('--i', i++); inner.textContent = p;
            w.appendChild(inner); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
      });
    }
    walk(el);
    if (label) el.setAttribute('aria-label', label);
    el.classList.add('mb-split-ready');
  }

  function titles(scope) {
    scope.querySelectorAll('.mb-title, .mb-quote, .mb-hero__h, .mb-phero__body h1').forEach(function (el) {
      if (el.closest('[data-mb-nosplit]')) return;
      splitWords(el);
      if (el.closest('.mb-hero, .mb-phero')) {
        requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-words-in'); }); });
      } else { watch(el); }
    });
    scope.querySelectorAll('.mb-eyebrow').forEach(function (el) {
      if (el.dataset.mbEye) return; el.dataset.mbEye = '1'; watch(el);
    });
  }

  /* ---------- 2. Rideaux sur les images + parallaxe ---------- */
  var parallaxEls = [];
  function masks(scope) {
    var sel = '.mb-split__media > div, .mb-story__imgs > div, .mb-close__media';
    scope.querySelectorAll(sel).forEach(function (el, idx) {
      if (el.hasAttribute('data-mb-mask') || el.closest('.mb-hero')) return;
      if (!el.querySelector('img')) return;
      el.setAttribute('data-mb-mask', '');
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--mb-delay', Math.min(sib, 4) * 140 + 'ms');
      watch(el);
      el.setAttribute('data-mb-parallax', ''); parallaxEls.push(el);
    });
  }

  /* ---------- 3. Pages Horizon (grilles produit, pied de page) ---------- */
  function horizon(scope) {
    var groups = [
      ['.product-grid__item, .resource-list__item, .collection-card', 'up', true],
      ['footer .shopify-section', 'fade', false],
      ['.product-recommendations', 'up', false]
    ];
    groups.forEach(function (g) {
      scope.querySelectorAll(g[0]).forEach(function (el) {
        if (el.hasAttribute('data-mb-reveal')) return;
        el.setAttribute('data-mb-reveal', g[1]);
        if (g[2] && el.parentElement) {
          var i = Array.prototype.indexOf.call(el.parentElement.children, el) % 4;
          el.style.setProperty('--mb-delay', i * 90 + 'ms');
        }
        watch(el);
      });
    });
  }

  /* ---------- 4. Boucle de défilement : progression, parallaxe, bandeaux ---------- */
  var bar = null, marquees = [], lastY = window.scrollY, skew = 0, ticking = false;
  function onFrame() {
    ticking = false;
    var y = window.scrollY, vh = window.innerHeight;
    if (bar) {
      var max = doc.documentElement.scrollHeight - vh;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(y / max, 1) : 0).toFixed(4) + ')';
    }
    if (window.innerWidth >= 750) {
      parallaxEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        var img = el.querySelector('img.mb-img');
        if (img) img.style.translate = '0 ' + (p * -7).toFixed(2) + '%';
      });
    }
    var v = y - lastY; lastY = y;
    var target = Math.max(-8, Math.min(8, v * 0.35));
    skew += (target - skew) * 0.25;
    if (Math.abs(skew) < 0.05) skew = 0;
    marquees.forEach(function (m) { m.style.setProperty('--mb-skew', (-skew).toFixed(2) + 'deg'); });
    if (skew !== 0) request();
  }
  function request() { if (!ticking) { ticking = true; requestAnimationFrame(onFrame); } }

  /* ---------- 5. Boutons magnétiques ---------- */
  function magnets(scope) {
    if (!fine || reduce) return;
    scope.querySelectorAll('.mb-btn, .mb-pill, .mb-uni__arrow').forEach(function (b) {
      if (b.dataset.mbMag) return; b.dataset.mbMag = '1';
      b.classList.add('mb-magnet');
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.22;
        var y = (e.clientY - r.top - r.height / 2) * 0.32;
        b.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- 6. Cartes en 3D ---------- */
  function tilts(scope) {
    if (!fine || reduce) return;
    scope.querySelectorAll('.mb-pcard, .mb-tile, .mb-way').forEach(function (c) {
      if (c.dataset.mbTilt) return; c.dataset.mbTilt = '1';
      c.classList.add('mb-tilt');
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        c.classList.add('is-tilting');
        c.style.transform = 'perspective(900px) rotateX(' + (py * -6).toFixed(2) + 'deg) rotateY(' + (px * 7).toFixed(2) + 'deg) translateY(-6px)';
      });
      c.addEventListener('pointerleave', function () { c.classList.remove('is-tilting'); c.style.transform = ''; });
    });
  }

  /* ---------- 7. Curseur ---------- */
  function cursor() {
    if (!fine || reduce || cfg.cursor === false || design) return;
    var c = doc.createElement('div'); c.className = 'mb-cursor'; c.setAttribute('aria-hidden', 'true');
    c.innerHTML = '<span class="mb-cursor__t">Voir</span>';
    doc.body.appendChild(c);
    var tx = -100, ty = -100, x = -100, y = -100, raf = null;
    function loop() {
      x += (tx - x) * 0.2; y += (ty - y) * 0.2;
      c.style.translate = x.toFixed(1) + 'px ' + y.toFixed(1) + 'px';
      raf = (Math.abs(tx - x) > 0.1 || Math.abs(ty - y) > 0.1) ? requestAnimationFrame(loop) : null;
    }
    doc.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      tx = e.clientX; ty = e.clientY; c.classList.add('is-on');
      if (!raf) raf = requestAnimationFrame(loop);
      var t = e.target;
      var view = t.closest && t.closest('.mb-pcard, .mb-tile, .mb-bento__main, .mb-bento__promo, .mb-bento__side, .product-grid__item a, .product-card a');
      var link = !view && t.closest && t.closest('a, button, summary, label, select, input, [role="button"]');
      c.classList.toggle('is-view', !!view);
      c.classList.toggle('is-link', !!link);
    }, { passive: true });
    doc.addEventListener('pointerdown', function () { c.classList.add('is-down'); });
    doc.addEventListener('pointerup', function () { c.classList.remove('is-down'); });
    doc.addEventListener('mouseleave', function () { c.classList.remove('is-on'); });
  }

  /* ---------- Init ---------- */
  function init(scope) {
    scope = scope || doc;
    titles(scope); horizon(scope); magnets(scope); tilts(scope);
    marquees = Array.prototype.slice.call(doc.querySelectorAll('.mb-marquee'));
    request();
  }

  function start() {
    if (cfg.progress !== false && !reduce) {
      bar = doc.createElement('div'); bar.className = 'mb-progress'; bar.setAttribute('aria-hidden', 'true');
      doc.body.appendChild(bar);
    }
    init(doc);
    cursor();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);

    /* Nouveaux produits chargés (filtres, pagination) */
    var main = doc.getElementById('MainContent');
    if (main && 'MutationObserver' in window) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () { pending = null; horizon(main); tilts(main); magnets(main); }, 120);
      }).observe(main, { childList: true, subtree: true });
    }

    /* Sécurité : tout afficher si quelque chose bloque */
    setTimeout(function () {
      doc.querySelectorAll('[data-mb-mask]:not(.is-in), .mb-split-ready:not(.is-words-in), [data-mb-reveal]:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('is-in'); el.classList.add('is-words-in'); }
      });
    }, 2600);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
